var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsCheckin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeOpacity: 0.01,
    strokeWidth: 0.01,
    d: "M0 0h24v24H0V0z",
    transform: "translate(-948 -1364) translate(925 1251) translate(23 80) translate(0 33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43A4F1",
    d: "M18.997 2C20.103 2 21 2.898 21 3.99v16.02c0 1.099-.894 1.99-2.003 1.99H8v-2h11V4H8V2h10.997zM8 6.087l5.92 5.92L8 17.927v-2.864L10.03 13H2v-2h8.016L8 8.951V6.087z",
    transform: "translate(-948 -1364) translate(925 1251) translate(23 80) translate(0 33)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCheckin);
export default __webpack_public_path__ + "static/media/icons-checkin.02702fd3cf1f7a2358895c00e0e09c14.svg";
export { ForwardRef as ReactComponent };